import type { Post as ApiPost, PostComment as ApiPostComment } from "@/adapters/api";
import { toReactionType, toReactionTypes } from "../reactions.ts";
import type { Comment, Post } from "../types.ts";

export function toPost(p: ApiPost): Post {
	return {
		id: p.id,
		date: p.occurred_at,
		author: {
			id: p.author?.id,
			name: p.author?.name,
			role: p.author?.role,
			removed: p.author?.removed ?? false,
		},
		title: p.title,
		body: p.body,
		internal: p.internal,
		status: p.status,
		weather: p.weather_condition,
		stage: p.stage ? { id: p.stage.id, name: p.stage.name } : undefined,
		parentPostId: p.parent_post_id,
		chain: p.chain?.map((entry) => ({
			id: entry.id,
			title: entry.title,
			date: entry.occurred_at,
		})),
		reactions: {
			count: p.reactions?.count ?? 0,
			reacted: p.reactions?.reacted ?? false,
			type: toReactionType(p.reactions?.type),
			types: toReactionTypes(p.reactions?.types),
		},
		commentCount: p.comment_count ?? 0,
		createdAt: p.created_at,
		updatedAt: p.updated_at,
		media: (p.media ?? []).map((item) => ({
			id: item.id,
			type: item.type,
			url: item.url,
			caption: item.caption,
			processingStatus: item.processing_status,
			thumbnailUrl: item.thumbnail_url,
			durationMs: item.duration_ms,
			width: item.width,
			height: item.height,
		})),
	};
}

export function toComment(c: ApiPostComment): Comment {
	return {
		id: c.id,
		author: {
			id: c.author?.id,
			name: c.author?.name,
			role: c.author?.role,
			removed: c.author?.removed ?? false,
		},
		body: c.body,
		mentions: (c.mentions ?? []).map((m) => ({ id: m.id, name: m.name })),
		createdAt: c.created_at,
	};
}
